import type { CheckForKeysNeedingRegeneratingResult } from "@/services/abstract/poc/messaging.service.interface";
import type { HeliaNode } from "@/types/poc/helia";
import type { LibP2pWithServices } from "@/types/poc/libp2p";
import type { MessageHandler, MessagePayload } from "@/types/poc/message";
import { createLogger, type Logger } from "@/utils/logger";

const log: Logger = createLogger({ namespace: 'six3ro:p2p:handlers:check-for-keys-needing-regenerating' });

export const createCheckForKeysNeedingRegeneratingHandler = (): MessageHandler<CheckForKeysNeedingRegeneratingResult> => ({
  canHandle: (_topic: string, message: MessagePayload): boolean =>
    message.type === 'check-for-keys-needing-regenerating',

  process: (
    message: MessagePayload,
    _libp2p: LibP2pWithServices,
    _heliaNode: HeliaNode | null
  ): CheckForKeysNeedingRegeneratingResult => {
    if (message.type !== 'check-for-keys-needing-regenerating') {
      throw new Error(`Invalid message type: expected 'check-for-keys-needing-regenerating', got '${message.type}'`);
    }

    const { sixId, sender, timestamp } = message;
    log.info('Received check-for-keys-needing-regenerating for six:', sixId, 'from', sender);

    return {
      sixId,
      sender,
      messageTimestamp: timestamp
    };
  }
});
